import VMain from './VMain'

export { VMain }

export default VMain
